import { TreeTableDesignTokens } from '@primeuix/themes/types/treetable';
import componentCommon from '../one-ds-tokens/OneDS-Component-Common.json';
import componentColorScheme from '../one-ds-tokens/OneDS-Component-Color-Scheme.json';
import { tDeep, tNum } from '../token-utils';

// https://github.com/primefaces/primeuix/blob/main/packages/themes/src/presets/aura/treetable/index.ts
const tt = tDeep(componentCommon.treetable);
const ttCs = tDeep(componentColorScheme.treetable);

export const TreetableTelekomDT: TreeTableDesignTokens = {
  header: {
    background: tt.header.background,
    color: tt.header.color,
    borderWidth: tt.header.border.width,
    padding: `${tt.header.padding.y} ${tt.header.padding.x}`,
  },
  headerCell: {
    background: tt.header.cell.background,
    hoverBackground: tt.header.cell.hover.background,
    selectedBackground: tt.header.cell.selected.background,
    color: tt.header.cell.color,
    hoverColor: tt.header.cell.hover.color,
    selectedColor: tt.header.cell.selected.color,
    gap: tt.header.cell.gap,
    padding: `${tt.header.cell.padding.y} ${tt.header.cell.padding.x}`,
    focusRing: {
      width: tt.header.cell.focus.ring.width,
      offset: tt.header.cell.focus.ring.offset,
      color: tt.header.cell.focus.ring.color,
    },
  },
  columnTitle: {
    fontWeight: tNum(componentCommon.treetable.column.title.font.weight),
  },
  columnFooter: {
    fontWeight: tNum(componentCommon.treetable.column.footer.font.weight),
  },
  columnResizer: {
    width: tt.column.resizer.width,
  },
  row: {
    background: tt.row.background,
    hoverBackground: tt.row.hover.background,
    selectedBackground: tt.row.selected.background,
    color: tt.row.color,
    hoverColor: tt.row.hover.color,
    selectedColor: tt.row.selected.color,
    focusRing: {
      width: tt.row.focus.ring.width,
      offset: tt.row.focus.ring.offset,
      color: tt.row.focus.ring.color,
    },
  },
  bodyCell: {
    gap: tt.body.cell.gap,
    padding: `${tt.body.cell.padding.y} ${tt.body.cell.padding.x}`,
  },
  footerCell: {
    background: tt.footer.cell.background,
    color: tt.footer.cell.color,
    padding: `${tt.footer.cell.padding.y} ${tt.footer.cell.padding.x}`,
  },
  footer: {
    background: tt.footer.background,
    color: tt.footer.color,
    borderWidth: tt.footer.border.width,
    padding: `${tt.footer.padding.y} ${tt.footer.padding.x}`,
  },
  resizeIndicator: {
    width: tt.resize.indicator.width,
    color: tt.resize.indicator.color,
  },
  sortIcon: {
    color: tt.sort.icon.color,
    hoverColor: tt.sort.icon.hover.color,
    size: tt.sort.icon.size,
  },
  loadingIcon: {
    size: tt.loading.icon.size,
  },
  nodeToggleButton: {
    hoverBackground: tt.node.toggle.button.hover.background,
    selectedHoverBackground: tt.node.toggle.button.selected.hover.background,
    color: tt.node.toggle.button.color,
    hoverColor: tt.node.toggle.button.hover.color,
    selectedHoverColor: tt.node.toggle.button.selected.hover.color,
    size: tt.node.toggle.button.size,
    borderRadius: tt.node.toggle.button.border.radius,
    focusRing: {
      width: tt.node.toggle.button.focus.ring.width,
      offset: tt.node.toggle.button.focus.ring.offset,
      color: tt.node.toggle.button.focus.ring.color,
    },
  },
  paginatorTop: {
    borderColor: tt.paginator.top.border.color,
    borderWidth: tt.paginator.top.border.width,
  },
  paginatorBottom: {
    borderColor: tt.paginator.bottom.border.color,
    borderWidth: tt.paginator.bottom.border.width,
  },
  colorScheme: {
    light: {
      root: {
        borderColor: ttCs.border.color,
      },
      bodyCell: {
        selectedBorderColor: ttCs.body.cell.selected.border.color,
      },
    },
  },
};
